import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de seguir?',
    a: 'No, está diseñado específicamente para mujeres con agendas llenas. Las recetas son prácticas y se preparan en 15 minutos o menos.'
  }, {
    q: '¿Tengo que comprar los productos de Herbalife?',
    a: 'El plan te enseña a comer de forma anti-inflamatoria, pero los productos son el catalizador recomendado para lograr resultados reales y sostenibles en solo 21 días.'
  }, {
    q: '¿Es seguro si tengo sofocos intensos?',
    a: 'Sí, de hecho el protocolo está diseñado específicamente para calmar el sistema nervioso y ayudar a regular la temperatura corporal a través de la nutrición.'
  }];
  return <section className="bg-white py-24 px-6 border-t border-copper/10" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <FadeIn className="text-center mb-16" data-id="element-33">
          <h2 className="text-4xl font-serif text-charcoal mb-4" data-id="element-34">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-copper mx-auto" data-id="element-35"></div>
        </FadeIn>

        <StaggerContainer className="space-y-8" data-id="element-36">
          {faqs.map((faq, idx) => <StaggerItem key={idx} className="bg-cream/50 p-8 rounded-sm" data-id="element-37">
              <h3 className="text-xl font-serif text-charcoal font-bold mb-3" data-id="element-38">
                {faq.q}
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-39">{faq.a}</p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}